import { render, staticRenderFns } from "./customerContractCopy.vue?vue&type=template&id=7a97d1d2"
import script from "./customerContractCopy.vue?vue&type=script&lang=js"
export * from "./customerContractCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports